<template>
  <div>
    <h1>Unidades</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn to="/branch" text><v-icon>add</v-icon> Novo</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-card>
            <v-card-title primary-title>
              <v-text-field
                v-model="searchText"
                append-icon="search"
                label="Buscar"
                v-on:keyup.enter="request()"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="pagination.current"
                :total-visible="Math.min(6, pagination.totalPages)"
                :length="pagination.totalPages"
                @input="request()"
                @next="request()"
                @previous="request()"
              ></v-pagination>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              hide-default-footer
              class="elevation-1"
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>

              <template slot="no-data">
                <v-alert :value="true" color="warning" icon="warning"
                  >Nenhum registro encontrado :(</v-alert
                >
              </template>

              <template slot="item" slot-scope="props">
                <tr>
                  <td>
                    <v-btn small text icon :to="`/branch/${props.item.id}`"
                      ><v-icon>edit</v-icon></v-btn
                    >
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.city }}</td>
                  <td>{{ props.item.stateCode }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-card-actions>
              <span class="caption grey--text font-italic"
                >{{ pagination.totalItems }} registros encontrados</span
              >
              <v-spacer></v-spacer>
              <v-pagination
                v-model="pagination.current"
                :total-visible="Math.min(6, pagination.totalPages)"
                :length="pagination.totalPages"
                @input="request()"
                @next="request()"
                @previous="request()"
              ></v-pagination>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import api from "@/api";
export default {
  name: "branch-list",
  data() {
    return {
      searchText: "",
      loading: false,
      pagination: {
        current: 1,
        totalPages: 0,
        totalItems: 0
      },
      items: [],
      headers: [
        {
          text: "",
          value: "id",
          sortable: false,
          width: 20
        },
        {
          text: "Nome",
          value: "name",
          sortable: false
        },
        {
          text: "Cidade",
          value: "city",
          sortable: false
        },
        {
          text: "UF",
          value: "state",
          sortable: false
        }
      ]
    };
  },
  methods: {
    request() {
      this.loading = true;
      api
        .request(
          "GET",
          `/branches/?pageSize=10&pageIndex=${this.pagination.current -
            1}&searchFor=${encodeURIComponent(this.searchText || "")}`
        )
        .then(response => {
          this.loading = false;
          this.items = response.data.items;
          this.pagination.totalItems = response.data.totalItems;
          this.pagination.totalPages = Math.ceil(
            response.data.totalItems / response.data.currentPageSize
          );
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    searchText() {
      this.pagination.current = 1;
    }
  },
  mounted() {
    this.search = null;
    this.pagination.current = 1;
    this.request();
  }
};
</script>
